import { useEffect, useState } from "react";
// 1. Import AOS untuk animasi scroll
import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaBath,
  FaBed,
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt,
  FaMountain,
  FaSearch,
  FaShieldAlt,
  FaStar,
  FaUsers
} from "react-icons/fa";

import { Link, useNavigate } from "react-router-dom";

import heroImage from "../assets/herovilla1.jpg";
import Footer from "../components/Footer";
import API_BASE_URL from "../config";
import "./css/Landingpage.css";

function Landingpage() {
  const navigate = useNavigate();

  const [location, setLocation] = useState("");
  const [guests, setGuests] = useState("1");
  
  const [villas, setVillas] = useState([]);
  const [loading, setLoading] = useState(true);

  const [testimonials, setTestimonials] = useState([]);
  const [loadingTestimonial, setLoadingTestimonial] = useState(true);

  // State tambahan untuk deteksi scroll (Sticky Navbar)
  const [isScrolled, setIsScrolled] = useState(false);

  // State untuk Recently Viewed
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  useEffect(() => {
    // 2. Inisialisasi AOS
    AOS.init({
      duration: 1000,
      once: true,
    });

    // Event listener untuk handle sticky navbar
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Fetch data villa
    fetch(`${API_BASE_URL}/api/villas`)
      .then(res => {
        if (!res.ok) throw new Error('Server error');
        return res.json();
      })
      .then(data => {
        setVillas(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Gagal mengambil data villa:", err);
        setLoading(false);
      });

    // Fetch data testimonial
    fetch(`${API_BASE_URL}/api/testimonials`)
      .then(res => {
        if (!res.ok) throw new Error('Server error');
        return res.json();
      })
      .then(data => {
        setTestimonials(data);
        setLoadingTestimonial(false);
      })
      .catch(err => {
        console.error("Gagal mengambil data testimonial:", err);
        setLoadingTestimonial(false);
      });

    // Load Recently Viewed dari local storage
    try {
      const savedHistory = localStorage.getItem("recentlyViewedVillas");
      if (savedHistory) {
        setRecentlyViewed(JSON.parse(savedHistory));
      }
    } catch (e) {
      console.error("Gagal membaca history:", e);
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSearch = () => {
    navigate(`/villas?location=${location}&guests=${guests}`);
  };

  const handleClearHistory = () => {
    localStorage.removeItem("recentlyViewedVillas");
    setRecentlyViewed([]);
  };

  const formatTimeAgo = (timestamp) => {
    if (!timestamp) return "";
    const seconds = Math.floor((new Date() - timestamp) / 1000);
    
    let interval = seconds / 86400;
    if (interval >= 1) return Math.floor(interval) + " days ago";
    
    interval = seconds / 3600;
    if (interval >= 1) return Math.floor(interval) + " hours ago";
    
    interval = seconds / 60;
    if (interval >= 1) return Math.floor(interval) + " minutes ago";
    
    return "just now";
  };

  return (
    <div className="landing">

      {/* NAVBAR */}
      <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
        <div className="logo">
          <div className="logo-icon">
            <FaMountain />
          </div>
          <div className="logo-text">
            <h3>Permata Wisata</h3>
            <span>Jogja Tourism</span>
          </div>
        </div>

        <div className="nav-menu">
          <Link to="/" className="active">Home</Link>
          <Link to="/villas">Villas</Link>
          <a
            href="https://wa.me/081216687367?text=Halo%20admin%20Permata%20Wisata,%20saya%20ingin%20bertanya%20tentang%20villa"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn"
          >
            Contact Us
          </a>
        </div>
      </nav>

      {/* HERO SECTION */}
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-overlay">
          <h1 data-aos="zoom-in">Discover Your Perfect Villa</h1>
          <p data-aos="fade-up" data-aos-delay="200">Experience the beauty of Jogja with comfort and luxury</p>

          <div className="search-box" data-aos="fade-up" data-aos-delay="400">
            <div className="search-item">
              <label><FaMapMarkerAlt /> Location</label>
              <input
                placeholder="Enter location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
            </div>

            <div className="search-item">
              <label><FaCalendarAlt /> Check-in</label>
              <input type="date" />
            </div>

            <div className="search-item">
              <label><FaCalendarAlt /> Check-out</label>
              <input type="date" />
            </div>

            <div className="search-item">
              <label>Guests</label>
              <select value={guests} onChange={(e) => setGuests(e.target.value)}>
                <option value="1">1 Guest</option>
                <option value="2">2 Guests</option>
                <option value="3">3 Guests</option>
                <option value="4">4 Guests</option>
                <option value="5">5 Guests</option>
                <option value="6">6 Guests</option>
              </select>
            </div>

            <button className="search-btn" onClick={handleSearch}>
              <FaSearch /> Search
            </button>
          </div>
        </div>
      </section>

      {/* RECENT VIEWED */}
      {recentlyViewed.length > 0 && (
        <section className="recent" data-aos="fade-right">
          <div className="container">
            <div className="recent-header">
              <h3>Recently Viewed</h3>
              <span className="clear" onClick={handleClearHistory} style={{ cursor: "pointer" }}>Clear History</span>
            </div>
            <div className="recent-cards-container" style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginTop: "15px" }}>
              {recentlyViewed.map(villa => (
                <Link 
                  to={`/villas/${villa.id}`} 
                  key={villa.id}
                  style={{ textDecoration: 'none', color: 'inherit', flex: "1 1 300px", maxWidth: "400px" }}
                >
                  <div className="recent-card" style={{ display: "flex", alignItems: "center", gap: "15px", backgroundColor: "#fff", border: "1px solid #eaeaea", borderRadius: "10px", padding: "10px", boxShadow: "0 2px 5px rgba(0,0,0,0.05)" }}>
                    <img src={villa.img} alt={villa.name} style={{ width: "90px", height: "90px", objectFit: "cover", borderRadius: "8px" }} />
                    <div className="recent-info">
                      <h4 style={{ margin: "0 0 5px 0", fontSize: "1.05rem", color: "#333", display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{villa.name}</h4>
                      <p style={{ margin: "0 0 5px 0", fontSize: "0.85rem", color: "#666" }}>max. {villa.guests} guests</p>
                      <span className="price" style={{ fontWeight: "bold", color: "#2ece7a", fontSize: "0.95rem" }}>From Rp {villa.price?.toLocaleString()}</span>
                      <small style={{ display: "block", marginTop: "5px", fontSize: "0.75rem", color: "#999" }}>Viewed {formatTimeAgo(villa.viewedAt)}</small>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* STATS SECTION */}
      <section className="stats">
        <div className="container">
          <div className="stat" data-aos="fade-up" data-aos-delay="100">
            <h2>120+</h2>
            <p>Luxury Villas</p>
          </div>
          <div className="stat" data-aos="fade-up" data-aos-delay="200">
            <h2>5K+</h2>
            <p>Happy Guests</p>
          </div>
          <div className="stat" data-aos="fade-up" data-aos-delay="300">
            <h2>4.9</h2>
            <p>Average Rating</p>
          </div>
          <div className="stat" data-aos="fade-up" data-aos-delay="400">
            <h2>24/7</h2>
            <p>Customer Support</p>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="how">
        <div className="container">
          <h2 data-aos="fade-down">Cara Kerja</h2>
          <p className="how-subtitle" data-aos="fade-down">Booking villa impianmu hanya dalam beberapa langkah mudah</p>
          <div className="how-container">
            <div className="how-card" data-aos="flip-left" data-aos-delay="100">
              <div className="how-icon">🔍</div>
              <h3>Cari Villa</h3>
              <p>Temukan villa sesuai lokasi dan jumlah tamu</p>
            </div>
            <div className="how-card" data-aos="flip-left" data-aos-delay="200">
              <div className="how-icon">📅</div>
              <h3>Pilih Tanggal</h3>
              <p>Tentukan tanggal check-in dan check-out dengan mudah</p>
            </div>
            <div className="how-card" data-aos="flip-left" data-aos-delay="300">
              <div className="how-icon">💳</div>
              <h3>Lakukan Pembayaran</h3>
              <p>Pembayaran aman dengan berbagai metode</p>
            </div>
            <div className="how-card" data-aos="flip-left" data-aos-delay="400">
              <div className="how-icon">🏡</div>
              <h3>Nikmati Liburan</h3>
              <p>Check-in dan nikmati pengalaman menginap terbaik</p>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="why">
        <div className="container">
          <h2 data-aos="fade-up">Why Choose Permata Wisata?</h2>
          <div className="why-container">
            <div className="why-card" data-aos="zoom-in-up" data-aos-delay="100">
              <div className="why-icon"><FaShieldAlt /></div>
              <h3>Trusted & Secure</h3>
              <p>All our villas are verified and guaranteed safe for your stay</p>
            </div>
            <div className="why-card" data-aos="zoom-in-up" data-aos-delay="200">
              <div className="why-icon"><FaStar /></div>
              <h3>Best Locations</h3>
              <p>Prime locations in Jogja with stunning views</p>
            </div>
            <div className="why-card" data-aos="zoom-in-up" data-aos-delay="300">
              <div className="why-icon"><FaClock /></div>
              <h3>Easy Booking</h3>
              <p>Simple and fast booking process, confirmation in minutes</p>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURED VILLAS */}
      <section className="villas">
        <div className="container">
          <div className="villa-header" data-aos="fade-right">
            <div>
              <h2>Featured Villas</h2>
              <p>Handpicked villas for your perfect vacation</p>
            </div>
            <Link to="/villas" className="view-btn">View All Villas</Link>
          </div>

          {/* 1. Posisi container card dipastikan berada pas di tengah */}
          <div className="villa-container" style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "25px", margin: "0 auto", width: "100%" }}>
            {loading ? (
              <p style={{ textAlign: "center", width: "100%", padding: "40px 0" }}>Memuat data villa...</p>
            ) : villas.length === 0 ? (
              <p style={{ textAlign: "center", width: "100%", padding: "40px 0" }}>Tidak ada data villa ditemukan di database.</p>
            ) : (
              villas.slice(0, 3).map((villa, index) => (
                /* 2. Seluruh card bisa diklik & tinggi disamakan rata (height: 100%) */
                <Link 
                  to={`/villas/${villa.id}`} 
                  key={villa.id} 
                  className="villa-card-link" 
                  style={{ textDecoration: "none", color: "inherit", display: "flex" }}
                >
                  {/* 3. Kotakan diperkecil ke width: 280px dan dikunci tingginya agar seragam */}
                  <div 
                    className="villa-card" 
                    data-aos="fade-up" 
                    data-aos-delay={index * 100}
                    style={{ 
                      width: "280px", 
                      display: "flex", 
                      flexDirection: "column", 
                      height: "100%", 
                      minHeight: "420px", 
                      boxSizing: "border-box"
                    }}
                  >
                    <div className="villa-img" style={{ height: "170px", overflow: "hidden" }}>
                      <img 
                        src={`/images/villas/villa_${villa.id}/utama.png`} 
                        alt={villa.name} 
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        onError={(e) => {
                          e.target.src = "https://images.unsplash.com/photo-1572120360610-d971b9d7767c";
                        }}
                      />
                      <span className="badge green">Available</span>
                    </div>
                    
                    {/* Menggunakan display flex dan space-between di dalam body card agar tombol & harga sejajar di bawah */}
                    <div className="villa-info" style={{ padding: "15px", flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                      <div>
                        {/* Batasi baris judul maksimal 2 baris agar sisa konten card tidak terdorong ke bawah */}
                        <h3 style={{ fontSize: "1.05rem", marginBottom: "6px", minHeight: "44px", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                          {villa.name}
                        </h3>
                        <p className="location" style={{ fontSize: "0.85rem", marginBottom: "10px" }}><FaMapMarkerAlt /> {villa.location}</p>
                        <div className="villa-spec" style={{ fontSize: "0.8rem", gap: "8px", marginBottom: "10px" }}>
                          <span><FaUsers /> {villa.guests} guests</span>
                          <span><FaBed /> {villa.beds} beds</span>
                          <span><FaBath /> {villa.baths} baths</span>
                        </div>
                        <p className="rating" style={{ fontSize: "0.85rem", marginBottom: "10px" }}>
                          <FaStar className="star"/> {villa.rating}
                        </p>
                      </div>
                      <div className="price-row" style={{ paddingTop: "10px", borderTop: "1px solid #f0f0f0" }}>
                        <div>
                          <h4 style={{ fontSize: "1rem" }}>Rp {villa.price?.toLocaleString()}</h4>
                          <span style={{ fontSize: "0.75rem" }}>per night</span>
                        </div>
                        <button className="book-btn" style={{ padding: "6px 12px", fontSize: "0.85rem" }}>Book Now</button>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </div>
        </div>
      </section>

      {/* DYNAMIC TESTIMONIALS */}
      <section className="testimonial" data-aos="zoom-out" style={{ width: "100%", overflow: "hidden" }}>
        {/* 4. Membuat container pembungkus section ulasan rata tengah secara presisi */}
        <div className="container" style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
          <h2>Apa Kata Mereka?</h2>
          <p className="testimonial-sub">Pengalaman nyata dari pelanggan kami</p>
          
          <div className="testimonial-slider" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", maxWidth: "1200px", position: "relative" }}>
            <button 
              className="slider-btn left"
              onClick={() => {
                const container = document.querySelector(".testimonial-track");
                container.scrollBy({ left: -320, behavior: "smooth" });
              }}
            >
              ‹
            </button>

            {/* 5. Menambahkan gaya `justify-content: center` agar deretan kotakan ulasan tersusun rapi di tengah halaman */}
            <div className="testimonial-track" style={{ display: "flex", gap: "20px", overflowX: "auto", scrollBehavior: "smooth", padding: "20px 10px", width: "100%", justifyContent: "center" }}>
              {loadingTestimonial ? (
                <p style={{ textAlign: "center", width: "100%" }}>Memuat ulasan...</p>
              ) : testimonials.length === 0 ? (
                <p style={{ textAlign: "center", width: "100%" }}>Belum ada ulasan saat ini.</p>
              ) : (
                testimonials.map((testi) => (
                  <div className="testimonial-card" key={testi.id} style={{ flex: "0 0 290px", maxWidth: "290px", boxSizing: "border-box" }}>
                    <p>"{testi.comment}"</p>
                    <h4>{testi.name}</h4>
                    <span>{"⭐".repeat(testi.rating)}</span>
                  </div>
                ))
              )}
            </div>

            <button 
              className="slider-btn right"
              onClick={() => {
                const container = document.querySelector(".testimonial-track");
                container.scrollBy({ left: 320, behavior: "smooth" });
              }}
            >
              ›
            </button>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta" data-aos="zoom-in">
        <div className="cta-icon">
          <FaMapMarkerAlt />
        </div>
        <h2>Ready to Start Your Journey?</h2>
        <p>
          Browse our collection of beautiful villas and homestays in Jogja.
          Book now and create unforgettable memories!
        </p>
        <Link to="/villas">
          <button>Explore All Villas</button>
        </Link>
      </section>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}

export default Landingpage;